/* @flow */

export const ROUTES = [
  "offerListView",
  "earnView",
  "accountTinkView",
  "redeemView",
  "newsListView",
  "leadsView",
  "questionnaireView",
  "currentInfoView1",
  "currentInfoView2",
  "currentInfoView3",
  "currentInfoView4",
  "currentInfoView5",
  "currentInfoView6",
  "currentInfoViewHome",
  "leaderboardView",
  "reportsView",
  "quizList",
  "calculatorView",
  "faqView",
  "formListView",
  "dynamicRoute1",
  "dynamicRoute2",
  "dynamicRoute3",
  "dynamicRoute4",
  "teamPot",
];

export const ADMIN_ROUTES = [
  "teamPot",
];
